module.exports = __webpack_public_path__ + "static/oyeleke-cc4530ff5ad41c531792cdb8827afa4c.png";